import React, { useState, useEffect } from 'react';
import apiClient from '../utils/apiClient';
import ContactForm from '../components/ContactForm';

const ContactPage = () => {
  const [contact, setContact] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    fetchContact();
  }, []);

  const fetchContact = async () => {
    setIsLoading(true);
    setError('');
    try {
      const response = await apiClient.get('/contact');
      setContact(response.data || null);
    } catch (err) {
      setError('Failed to load contact information');
      setContact(null);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditContact = () => {
    setShowModal(true);
  };

  const handleSaveContact = async (contactData) => {
    try {
      if (contact && contact.id) {
        const response = await apiClient.put(`/contact/${contact.id}`, contactData);
        setContact(response.data);
        showSuccess('Contact information updated successfully');
      } else {
        const response = await apiClient.post(`/contact`, contactData);
        setContact(response.data);
        showSuccess('Contact information created successfully');
      }
      setShowModal(false);
    } catch (err) {
      setError('Failed to save contact information');
    }
  };

  const showSuccess = (message) => {
    setSuccessMessage(message);
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  return (
    <div>
      <div className="content-header">
        <h2>Contact Information</h2>
        <button className="add-btn" onClick={handleEditContact}>
          ✏️ {contact ? 'Edit' : 'Add'} Contact
        </button>
      </div>

      {successMessage && <div className="alert alert-success">{successMessage}</div>}
      {error && <div className="alert alert-error">{error}</div>}

      {isLoading ? (
        <div className="table-container">
          <div className="no-data">Loading contact information...</div>
        </div>
      ) : contact ? (
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          {/* Profile Section */}
          <div style={{ backgroundColor: 'white', borderRadius: '8px', padding: '30px', textAlign: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', marginBottom: '20px' }}>
            {contact.profileImage ? (
              <img 
                src={contact.profileImage} 
                alt="Profile" 
                style={{ width: '120px', height: '120px', borderRadius: '50%', objectFit: 'cover', marginBottom: '15px', border: '4px solid #2196F3' }}
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="120" height="120"%3E%3Crect fill="%23ddd" width="120" height="120"/%3E%3Ctext x="50%" y="50%" text-anchor="middle" dy=".3em" fill="%23999" font-size="14"%3ENo Image%3C/text%3E%3C/svg%3E';
                }}
              />
            ) : (
              <div style={{ width: '120px', height: '120px', borderRadius: '50%', backgroundColor: '#e0e0e0', margin: '0 auto 15px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '48px' }}>👤</div>
            )}
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Contact Information</h3>
            <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>{contact.email || 'No email provided'}</p>
          </div>

          {/* Contact Details Grid */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px' }}>
            <ContactInfoCard icon="📧" label="Email" value={contact.email} />
            <ContactInfoCard icon="📍" label="Location" value={contact.location} />
            <ContactInfoCard icon="🔗" label="GitHub" value={contact.github} />
            <ContactInfoCard icon="💼" label="LinkedIn" value={contact.linkedin} />
            <ContactInfoCard icon="🐦" label="Twitter" value={contact.twitter} />
            <ContactInfoCard icon="🇹🇭" label="Thailand Phone" value={contact.thailandPhone} />
            <ContactInfoCard icon="🇲🇲" label="Myanmar Phone" value={contact.myanmarPhone} />
            <ContactInfoCard icon="📱" label="Viber" value={contact.viber} />
            <ContactInfoCard icon="💬" label="WhatsApp" value={contact.whatsapp} />
            <ContactInfoCard icon="📲" label="Line ID" value={contact.lineId} />
          </div>
        </div>
      ) : (
        <div className="table-container">
          <div className="no-data">No contact information yet.</div>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <ContactForm
              contact={contact}
              onSave={handleSaveContact}
              onCancel={() => setShowModal(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const ContactInfoCard = ({ icon, label, value }) => (
  <div className="message-card" style={{ borderLeftColor: '#16a085' }}>
    <h4>{icon} {label}</h4>
    <p style={{ wordBreak: 'break-all' }}>{value || 'Not provided'}</p>
  </div>
);

export default ContactPage;
